import React, { useEffect, useState } from "react";
import { Container, Navbar, Nav, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Image from "react-bootstrap/Image";
import { IMAGES } from "../images/images";

const Header = () => {
  const location = useLocation(); // once ready it returns the 'window.location' object
  const [url, setUrl] = useState(null);
  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);

  // Sticky Menu Area
  // useEffect(() => {
    
  // });
  useEffect(() => {
    const targetId = sessionStorage.getItem("scrollToSection");
    if (targetId) {
      const element = document.getElementById(targetId);
      if (element) {
        setTimeout(() => { // Ensure the page has fully loaded before scrolling
          window.scrollTo({
            top: element.offsetTop,
            behavior: "smooth",
          });
        }, 100);
      }
      sessionStorage.removeItem("scrollToSection"); // Clean up
    }
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);
  
  /* Method that will fix header after a specific scrollable */
  const isSticky = (e) => {
    const header = document.querySelector(".navbar");
    const scrollTop = window.scrollY;
    scrollTop >= 250
      ? header.classList.add("is-sticky")
      : header.classList.remove("is-sticky");
  };

  const data = [
    {
      pageName: "/home",
      title: "Home",
    },
    {
      pageName: "/about",
      title: "About",
    },
    {
      pageName: "/features",
      title: "Features",
    },
    {
      pageName: "/app",
      title: "Download Our App",
    },
  ];

  return (
    <Navbar collapseOnSelect expand="lg" id="home">
      <Container fluid>
        <Navbar.Brand as={Link} to="/">
          <Image src={IMAGES.Logo} width="160" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="m-auto">
            {data.map((item, index) => (
              <Nav.Link
              href={item.pageName}
              key={index}
              onClick={(e) => {
                e.preventDefault(); // Prevent default navigation behavior
            
                const targetId = item.pageName.replace("/", "");
                const element = document.getElementById(targetId);
                const baseURL = window.location.origin + "/";
            
                if (window.location.pathname !== "/") {
                  // If user is not on home page, redirect to home and store target section
                  if (!sessionStorage.getItem("scrollToSection")) {
                    sessionStorage.setItem("scrollToSection", targetId);
                    window.location.href = baseURL;
                  }
                } else if (element) {
                  // If already on home, scroll smoothly
                  window.scrollTo({
                    top: element.offsetTop,
                    behavior: "smooth",
                  });
                }
              }}
            >
              {item.title}
            </Nav.Link>
            
            ))}
          </Nav>

          <div className="btnBox">
            <Button as={Link} variant="outline-primary">
              Subscribe Today
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
